import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { apiGetGoodsDetail } from '../api';
import { AppStore, DetailRecord, Goods } from '../types';
interface RequestParams {
  id: string;
}

// 请求成功时传送的参数
interface SuccessParams extends RequestParams {
  record: Goods;
}
// 请求失败时传送的参数
interface FailureParams extends RequestParams {
  error: string;
}

type GoodsDetailType = {
  [id: string]: DetailRecord<Goods>;
};
const goodsDetailSlice = createSlice({
  name: 'goodsDetail',
  initialState: {} as GoodsDetailType,
  reducers: {
    goodsDetailRequest: (state: GoodsDetailType, action: PayloadAction<RequestParams>) => {
      if (!state[action.payload.id]) {
        state[action.payload.id] = { fetching: true, loaded: false } as DetailRecord<Goods>;
      }
      state[action.payload.id].fetching = true;
      return state;
    },
    goodsDetailSuccess: (state: GoodsDetailType, action: PayloadAction<SuccessParams>) => {
      if (!state[action.payload.id]) {
        state[action.payload.id] = { fetching: true, loaded: false } as DetailRecord<Goods>;
      }
      state[action.payload.id].fetching = false;
      state[action.payload.id].loaded = true;
      state[action.payload.id].result = action.payload.record;
      return state;
    },
    goodsDetailFailure: (state: GoodsDetailType, action: PayloadAction<FailureParams>) => {
      if (!state[action.payload.id]) {
        state[action.payload.id] = { fetching: true, loaded: false } as DetailRecord<Goods>;
      }
      state[action.payload.id].fetching = false;
      state[action.payload.id].loaded = true;
      state[action.payload.id].error = action.payload.error;
      return state;
    },
    goodsDetailClear: (state: GoodsDetailType) => {
      state = {};
      return state;
    },
  },
});

export const { goodsDetailRequest, goodsDetailSuccess, goodsDetailFailure, goodsDetailClear } =
  goodsDetailSlice.actions;
export default goodsDetailSlice.reducer;

export const goodsDetailEffect = {
  'goodsDetail/clear': (store: ToolkitStore<AppStore>) => store.dispatch(goodsDetailClear()),
  'goodsDetail/goodsDetailRequest': async (store: ToolkitStore<AppStore>, action: PayloadAction<RequestParams>) => {
    var detail = store.getState().goodsDetail[action.payload.id];
    if (detail?.loaded === true && !detail?.error) {
      store.dispatch(goodsDetailSuccess({ record: detail.result ?? {}, id: action.payload.id }));
    } else {
      try {
        let res = await apiGetGoodsDetail(action.payload.id);
        let data = res.data;
        if (data.code === 200) {
          store.dispatch(goodsDetailSuccess({ record: data.data, id: action.payload.id }));
        } else {
          store.dispatch(goodsDetailFailure({ error: data.msg || '获取失败', id: action.payload.id }));
        }
      } catch (e: any) {
        store.dispatch(goodsDetailFailure({ error: e.toString() || '获取失败', id: action.payload.id }));
      }
    }
  },
};
